(function () {
  function removeOldSearchDrawer() {
    var liveDrawer = document.querySelector('#SearchDrawer.coco-live-search');
    document.querySelectorAll('#SearchDrawer').forEach(function (drawer) {
      if (liveDrawer && drawer !== liveDrawer) drawer.remove();
    });
    document.querySelectorAll('#SearchDrawer .search-bar__close, #SearchDrawer .js-drawer-close').forEach(function (button) {
      if (!button.classList.contains('coco-live-search__close')) button.remove();
    });
    return liveDrawer;
  }

  function initCocoLiveSearch() {
    var drawer = removeOldSearchDrawer();
    if (!drawer || drawer.dataset.cocoSearchReady === 'true') return;

    var form = drawer.querySelector('[data-coco-search-form]');
    var input = drawer.querySelector('[data-coco-search-input]');
    var results = drawer.querySelector('[data-coco-search-results]');
    var status = drawer.querySelector('[data-coco-search-status]');
    var resultsHeading = drawer.querySelector('[data-coco-results-heading]');
    var rotatingWord = drawer.querySelector('[data-coco-rotating-word]');
    var closeButton = drawer.querySelector('.coco-live-search__close');
    var initialMarkup = results ? results.innerHTML : '';
    var timer, requestController, pageController;
    var currentQuery = '';
    var nextPageUrl = '';
    var loadingNextPage = false;

    if (!form || !input || !results) return;
    drawer.dataset.cocoSearchReady = 'true';

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        if (closeButton.dataset.cocoAllowClose === 'true') {
          delete closeButton.dataset.cocoAllowClose;
          return;
        }

        if (!window.matchMedia('(max-width: 749px)').matches) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.classList.add('is-coco-closing');
        document.body.classList.add('coco-search-is-closing');

        window.setTimeout(function () {
          closeButton.dataset.cocoAllowClose = 'true';
          closeButton.click();
          window.setTimeout(function () {
            drawer.classList.remove('is-coco-closing');
          }, 60);
          window.setTimeout(function () {
            document.body.classList.remove('coco-search-is-closing');
          }, 700);
        }, 260);
      }, true);
    }

    var rotatingWords = ['Books', 'Decks', 'Jewelry', 'Art'];
    var rotatingIndex = 0;

    function syncPrompt() {
      form.classList.toggle('has-query', input.value.trim().length > 0);
    }

    input.addEventListener('focus', function () {
      form.classList.add('is-focused');
    });

    input.addEventListener('blur', function () {
      form.classList.remove('is-focused');
      syncPrompt();
    });

    if (rotatingWord) {
      window.setInterval(function () {
        if (input.value.trim()) return;
        rotatingWord.classList.add('is-changing');
        window.setTimeout(function () {
          rotatingIndex = (rotatingIndex + 1) % rotatingWords.length;
          rotatingWord.textContent = rotatingWords[rotatingIndex];
          rotatingWord.classList.remove('is-changing');
        }, 250);
      }, 2800);
    }

    function restartOpeningAnimation() {
      drawer.classList.remove('is-coco-opening');
      drawer.offsetHeight;
      drawer.classList.add('is-coco-opening');
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[aria-controls="SearchDrawer"], [href="#SearchDrawer"], .js-drawer-open-top, .site-header__search-toggle');
      if (opener) restartOpeningAnimation();
    }, true);

    var wasThemeOpen = drawer.classList.contains('drawer--is-open');
    document.body.classList.toggle('coco-search-is-open', wasThemeOpen);
    new MutationObserver(function () {
      var isThemeOpen = drawer.classList.contains('drawer--is-open');
      if (isThemeOpen && !wasThemeOpen) restartOpeningAnimation();
      document.body.classList.toggle('coco-search-is-open', isThemeOpen);
      wasThemeOpen = isThemeOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function replaceResults(markup, message) {
      results.classList.add('is-changing');
      window.setTimeout(function () {
        results.innerHTML = markup;
        setStatus(message);
        requestAnimationFrame(function () {
          results.classList.remove('is-changing');
          bindNextPage();
        });
      }, 120);
    }

    function showInitial() {
      currentQuery = '';
      nextPageUrl = '';
      if (requestController) requestController.abort();
      if (pageController) pageController.abort();
      if (resultsHeading) resultsHeading.textContent = 'Trending';
      replaceResults(initialMarkup, '');
    }

    function sectionUrl(query, pageUrl) {
      var url = new URL(pageUrl || '/search', window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('section_id', 'search-template');
      return url.pathname + '?' + url.searchParams.toString();
    }

    function parseSearchSection(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var feed = parsed.querySelector('[data-coco-search-feed]');
      if (!feed) return null;
      return {
        markup: feed.innerHTML,
        count: feed.getAttribute('data-result-count') || '0',
        next: feed.getAttribute('data-next-url') || ''
      };
    }

    function search(query) {
      if (requestController) requestController.abort();
      if (pageController) pageController.abort();
      requestController = new AbortController();
      currentQuery = query;
      nextPageUrl = '';
      if (resultsHeading) resultsHeading.textContent = 'Results';
      setStatus('Searching…');

      fetch(sectionUrl(query), { signal: requestController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.text();
        })
        .then(function (html) {
          if (query !== currentQuery) return;
          var data = parseSearchSection(html);
          if (!data) throw new Error('Search section missing');
          nextPageUrl = data.next;
          var message = data.count === '1' ? '1 result for “' + query + '”' : data.count + ' results for “' + query + '”';
          replaceResults(data.markup, message);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') setStatus('Please try searching again.');
        });
    }

    function loadNextPage() {
      if (!nextPageUrl || loadingNextPage || !currentQuery) return;
      loadingNextPage = true;
      pageController = new AbortController();

      fetch(sectionUrl(currentQuery, nextPageUrl), { signal: pageController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Next search page failed');
          return response.text();
        })
        .then(function (html) {
          var data = parseSearchSection(html);
          if (!data) throw new Error('Search section missing');
          var parsed = new DOMParser().parseFromString('<div class="coco-temp">' + data.markup + '</div>', 'text/html');
          var grid = results.querySelector('.coco-live-search__grid');
          var oldSentinel = results.querySelector('[data-coco-search-sentinel]');
          if (oldSentinel) oldSentinel.remove();
          parsed.querySelectorAll('.coco-live-search__card').forEach(function (card) {
            if (grid) grid.appendChild(card);
          });
          var newSentinel = parsed.querySelector('[data-coco-search-sentinel]');
          if (grid && newSentinel) grid.appendChild(newSentinel);
          nextPageUrl = data.next;
          loadingNextPage = false;
          bindNextPage();
        })
        .catch(function (error) {
          loadingNextPage = false;
          if (error.name !== 'AbortError') setStatus('More results could not be loaded.');
        });
    }

    function bindNextPage() {
      var sentinel = results.querySelector('[data-coco-search-sentinel]');
      if (!sentinel || !nextPageUrl) return;
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          loadNextPage();
        }
      }, { root: drawer, rootMargin: '500px 0px' });
      observer.observe(sentinel);
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      syncPrompt();
      window.clearTimeout(timer);
      if (!query) {
        showInitial();
        return;
      }
      timer = window.setTimeout(function () { search(query); }, 180);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input.value.trim();
      if (query) search(query);
    });

    drawer.querySelectorAll('[data-coco-search-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var query = link.getAttribute('data-coco-search-link') || '';
        input.value = query;
        syncPrompt();
        if (query) search(query);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCocoLiveSearch);
  } else {
    initCocoLiveSearch();
  }
})();
